import { useEffect, useState } from 'react';

export const useStickyState = <T>(
    defaultValue: T,
    key: string,
    storage: Storage = sessionStorage
) => {
    const [value, setValue] = useState<T>(() => {
        const stickyValue = storage.getItem(key);
        return stickyValue !== null ? JSON.parse(stickyValue) : defaultValue;
    });
    useEffect(() => {
        storage.setItem(key, JSON.stringify(value));
    }, [key, value, storage]);
    return [value, setValue] as const;
};
